// src/app/shared/data/countries.ts
export const countries = [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bhutan',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Brazil',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Comoros',
    'Congo, Democratic Republic of the',
    'Congo, Republic of the',
    'Costa Rica',
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Eswatini',
    'Ethiopia',
    'Fiji',
    'Finland',
    'France',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Greece',
    'Grenada',
    'Guatemala',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Honduras',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
   // 'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Korea, North',
    'Korea, South',
    'Kosovo',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Micronesia',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'North Macedonia',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestine',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Qatar',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Vatican City',
    'Venezuela',
    'Vietnam',
    'Yemen',
    'Zambia',
    'Zimbabwe'
  ];
  
  export const countryCodes = [
    { code: '+93', flag: 'AFG', country: 'Afghanistan' },
    { code: '+355', flag: 'ALB', country: 'Albania' },
    { code: '+213', flag: 'DZA', country: 'Algeria' },
    { code: '+376', flag: 'AND', country: 'Andorra' },
    { code: '+244', flag: 'AGO', country: 'Angola' },
    { code: '+1-264', flag: 'AIA', country: 'Anguilla' },
    { code: '+1-268', flag: 'ATG', country: 'Antigua and Barbuda' },
    { code: '+54', flag: 'ARG', country: 'Argentina' },
    { code: '+374', flag: 'ARM', country: 'Armenia' },
    { code: '+297', flag: 'ABW', country: 'Aruba' },
    { code: '+61', flag: 'AUS', country: 'Australia' },
    { code: '+43', flag: 'AUT', country: 'Austria' },
    { code: '+994', flag: 'AZE', country: 'Azerbaijan' },
    { code: '+1-242', flag: 'BHS', country: 'Bahamas' },
    { code: '+973', flag: 'BHR', country: 'Bahrain' },
    { code: '+880', flag: 'BGD', country: 'Bangladesh' },
    { code: '+1-246', flag: 'BRB', country: 'Barbados' },
    { code: '+375', flag: 'BLR', country: 'Belarus' },
    { code: '+32', flag: 'BEL', country: 'Belgium' },
    { code: '+501', flag: 'BLZ', country: 'Belize' },
    { code: '+229', flag: 'BEN', country: 'Benin' },
    { code: '+1-441', flag: 'BMU', country: 'Bermuda' },
    { code: '+975', flag: 'BTN', country: 'Bhutan' },
    { code: '+591', flag: 'BOL', country: 'Bolivia' },
    { code: '+387', flag: 'BIH', country: 'Bosnia and Herzegovina' },
    { code: '+267', flag: 'BWA', country: 'Botswana' },
    { code: '+55', flag: 'BRA', country: 'Brazil' },
    { code: '+246', flag: 'IOT', country: 'British Indian Ocean Territory' },
    { code: '+1-284', flag: 'VGB', country: 'British Virgin Islands' },
    { code: '+673', flag: 'BRN', country: 'Brunei' },
    { code: '+359', flag: 'BGR', country: 'Bulgaria' },
    { code: '+226', flag: 'BFA', country: 'Burkina Faso' },
    { code: '+257', flag: 'BDI', country: 'Burundi' },
    { code: '+855', flag: 'KHM', country: 'Cambodia' },
    { code: '+237', flag: 'CMR', country: 'Cameroon' },
    { code: '+1', flag: 'CAN', country: 'Canada' },
    { code: '+238', flag: 'CPV', country: 'Cape Verde' },
    { code: '+1-345', flag: 'CYM', country: 'Cayman Islands' },
    { code: '+236', flag: 'CAF', country: 'Central African Republic' },
    { code: '+235', flag: 'TCD', country: 'Chad' },
    { code: '+56', flag: 'CHL', country: 'Chile' },
    { code: '+86', flag: 'CHN', country: 'China' },
    { code: '+61', flag: 'CXR', country: 'Christmas Island' },
    { code: '+61', flag: 'CCK', country: 'Cocos Islands' },
    { code: '+57', flag: 'COL', country: 'Colombia' },
    { code: '+269', flag: 'COM', country: 'Comoros' },
    { code: '+682', flag: 'COK', country: 'Cook Islands' },
    { code: '+506', flag: 'CRI', country: 'Costa Rica' },
    { code: '+385', flag: 'HRV', country: 'Croatia' },
    { code: '+53', flag: 'CUB', country: 'Cuba' },
    { code: '+599', flag: 'CUW', country: 'Curaçao' },
    { code: '+357', flag: 'CYP', country: 'Cyprus' },
    { code: '+420', flag: 'CZE', country: 'Czech Republic' },
    { code: '+243', flag: 'COD', country: 'Democratic Republic of the Congo' },
    { code: '+45', flag: 'DNK', country: 'Denmark' },
    { code: '+253', flag: 'DJI', country: 'Djibouti' },
    { code: '+1-767', flag: 'DMA', country: 'Dominica' },
    { code: '+1-809', flag: 'DOM', country: 'Dominican Republic' },
    { code: '+670', flag: 'TLS', country: 'East Timor' },
    { code: '+593', flag: 'ECU', country: 'Ecuador' },
    { code: '+20', flag: 'EGY', country: 'Egypt' },
    { code: '+503', flag: 'SLV', country: 'El Salvador' },
    { code: '+240', flag: 'GNQ', country: 'Equatorial Guinea' },
    { code: '+291', flag: 'ERI', country: 'Eritrea' },
    { code: '+372', flag: 'EST', country: 'Estonia' },
    { code: '+251', flag: 'ETH', country: 'Ethiopia' },
    { code: '+500', flag: 'FLK', country: 'Falkland Islands' },
    { code: '+298', flag: 'FRO', country: 'Faroe Islands' },
    { code: '+679', flag: 'FJI', country: 'Fiji' },
    { code: '+358', flag: 'FIN', country: 'Finland' },
    { code: '+33', flag: 'FRA', country: 'France' },
    { code: '+594', flag: 'GUF', country: 'French Guiana' },
    { code: '+689', flag: 'PYF', country: 'French Polynesia' },
    { code: '+241', flag: 'GAB', country: 'Gabon' },
    { code: '+220', flag: 'GMB', country: 'Gambia' },
    { code: '+995', flag: 'GEO', country: 'Georgia' },
    { code: '+49', flag: 'DEU', country: 'Germany' },
    { code: '+233', flag: 'GHA', country: 'Ghana' },
    { code: '+350', flag: 'GIB', country: 'Gibraltar' },
    { code: '+30', flag: 'GRC', country: 'Greece' },
    { code: '+299', flag: 'GRL', country: 'Greenland' },
    { code: '+1-473', flag: 'GRD', country: 'Grenada' },
    { code: '+590', flag: 'GLP', country: 'Guadeloupe' },
    { code: '+1-671', flag: 'GUM', country: 'Guam' },
    { code: '+502', flag: 'GTM', country: 'Guatemala' },
    { code: '+224', flag: 'GIN', country: 'Guinea' },
    { code: '+245', flag: 'GNB', country: 'Guinea-Bissau' },
    { code: '+592', flag: 'GUY', country: 'Guyana' },
    { code: '+509', flag: 'HTI', country: 'Haiti' },
    { code: '+504', flag: 'HND', country: 'Honduras' },
    { code: '+852', flag: 'HKG', country: 'Hong Kong' },
    { code: '+36', flag: 'HUN', country: 'Hungary' },
    { code: '+354', flag: 'ISL', country: 'Iceland' },
    { code: '+91', flag: 'IND', country: 'India' },
    { code: '+62', flag: 'IDN', country: 'Indonesia' },
    { code: '+98', flag: 'IRN', country: 'Iran' },
    { code: '+964', flag: 'IRQ', country: 'Iraq' },
    { code: '+353', flag: 'IRL', country: 'Ireland' },
   // { code: '+972', flag: 'ISR', country: 'Israel' },
    { code: '+39', flag: 'ITA', country: 'Italy' },
    { code: '+1-876', flag: 'JAM', country: 'Jamaica' },
    { code: '+81', flag: 'JPN', country: 'Japan' },
    { code: '+962', flag: 'JOR', country: 'Jordan' },
    { code: '+7', flag: 'KAZ', country: 'Kazakhstan' },
    { code: '+254', flag: 'KEN', country: 'Kenya' },
    { code: '+686', flag: 'KIR', country: 'Kiribati' },
    { code: '+383', flag: 'XKX', country: 'Kosovo' },
    { code: '+965', flag: 'KWT', country: 'Kuwait' },
    { code: '+996', flag: 'KGZ', country: 'Kyrgyzstan' },
    { code: '+856', flag: 'LAO', country: 'Laos' },
    { code: '+371', flag: 'LVA', country: 'Latvia' },
    { code: '+961', flag: 'LBN', country: 'Lebanon' },
    { code: '+266', flag: 'LSO', country: 'Lesotho' },
    { code: '+231', flag: 'LBR', country: 'Liberia' },
    { code: '+218', flag: 'LBY', country: 'Libya' },
    { code: '+423', flag: 'LIE', country: 'Liechtenstein' },
    { code: '+370', flag: 'LTU', country: 'Lithuania' },
    { code: '+352', flag: 'LUX', country: 'Luxembourg' },
    { code: '+853', flag: 'MAC', country: 'Macau' },
    { code: '+389', flag: 'MKD', country: 'North Macedonia' },
    { code: '+261', flag: 'MDG', country: 'Madagascar' },
    { code: '+265', flag: 'MWI', country: 'Malawi' },
    { code: '+60', flag: 'MYS', country: 'Malaysia' },
    { code: '+960', flag: 'MDV', country: 'Maldives' },
    { code: '+223', flag: 'MLI', country: 'Mali' },
    { code: '+356', flag: 'MLT', country: 'Malta' },
    { code: '+692', flag: 'MHL', country: 'Marshall Islands' },
    { code: '+596', flag: 'MTQ', country: 'Martinique' },
    { code: '+222', flag: 'MRT', country: 'Mauritania' },
    { code: '+230', flag: 'MUS', country: 'Mauritius' },
    { code: '+262', flag: 'MYT', country: 'Mayotte' },
    { code: '+52', flag: 'MEX', country: 'Mexico' },
    { code: '+691', flag: 'FSM', country: 'Micronesia' },
    { code: '+373', flag: 'MDA', country: 'Moldova' },
    { code: '+377', flag: 'MCO', country: 'Monaco' },
    { code: '+976', flag: 'MNG', country: 'Mongolia' },
    { code: '+382', flag: 'MNE', country: 'Montenegro' },
    { code: '+1-664', flag: 'MSR', country: 'Montserrat' },
    { code: '+212', flag: 'MAR', country: 'Morocco' },
    { code: '+258', flag: 'MOZ', country: 'Mozambique' },
    { code: '+95', flag: 'MMR', country: 'Myanmar' },
    { code: '+264', flag: 'NAM', country: 'Namibia' },
    { code: '+674', flag: 'NRU', country: 'Nauru' },
    { code: '+977', flag: 'NPL', country: 'Nepal' },
    { code: '+31', flag: 'NLD', country: 'Netherlands' },
    { code: '+687', flag: 'NCL', country: 'New Caledonia' },
    { code: '+64', flag: 'NZL', country: 'New Zealand' },
    { code: '+505', flag: 'NIC', country: 'Nicaragua' },
    { code: '+227', flag: 'NER', country: 'Niger' },
    { code: '+234', flag: 'NGA', country: 'Nigeria' },
    { code: '+683', flag: 'NIU', country: 'Niue' },
    { code: '+850', flag: 'PRK', country: 'North Korea' },
    { code: '+47', flag: 'NOR', country: 'Norway' },
    { code: '+968', flag: 'OMN', country: 'Oman' },
    { code: '+92', flag: 'PAK', country: 'Pakistan' },
    { code: '+680', flag: 'PLW', country: 'Palau' },
    { code: '+970', flag: 'PSE', country: 'Palestine' },
    { code: '+507', flag: 'PAN', country: 'Panama' },
    { code: '+675', flag: 'PNG', country: 'Papua New Guinea' },
    { code: '+595', flag: 'PRY', country: 'Paraguay' },
    { code: '+51', flag: 'PER', country: 'Peru' },
    { code: '+63', flag: 'PHL', country: 'Philippines' },
    { code: '+48', flag: 'POL', country: 'Poland' },
    { code: '+351', flag: 'PRT', country: 'Portugal' },
    { code: '+1-787', flag: 'PRI', country: 'Puerto Rico' },
    { code: '+974', flag: 'QAT', country: 'Qatar' },
    { code: '+242', flag: 'COG', country: 'Republic of the Congo' },
    { code: '+40', flag: 'ROU', country: 'Romania' },
    { code: '+7', flag: 'RUS', country: 'Russia' },
    { code: '+250', flag: 'RWA', country: 'Rwanda' },
    { code: '+590', flag: 'BLM', country: 'Saint Barthélemy' },
    { code: '+1-869', flag: 'KNA', country: 'Saint Kitts and Nevis' },
    { code: '+1-758', flag: 'LCA', country: 'Saint Lucia' },
    { code: '+590', flag: 'MAF', country: 'Saint Martin' },
    { code: '+508', flag: 'SPM', country: 'Saint Pierre and Miquelon' },
    { code: '+1-784', flag: 'VCT', country: 'Saint Vincent and the Grenadines' },
    { code: '+685', flag: 'WSM', country: 'Samoa' },
    { code: '+378', flag: 'SMR', country: 'San Marino' },
    { code: '+239', flag: 'STP', country: 'São Tomé and Príncipe' },
    { code: '+966', flag: 'SAU', country: 'Saudi Arabia' },
    { code: '+221', flag: 'SEN', country: 'Senegal' },
    { code: '+381', flag: 'SRB', country: 'Serbia' },
    { code: '+248', flag: 'SYC', country: 'Seychelles' },
    { code: '+232', flag: 'SLE', country: 'Sierra Leone' },
    { code: '+65', flag: 'SGP', country: 'Singapore' },
    { code: '+421', flag: 'SVK', country: 'Slovakia' },
    { code: '+386', flag: 'SVN', country: 'Slovenia' },
    { code: '+677', flag: 'SLB', country: 'Solomon Islands' },
    { code: '+252', flag: 'SOM', country: 'Somalia' },
    { code: '+27', flag: 'ZAF', country: 'South Africa' },
    { code: '+82', flag: 'KOR', country: 'South Korea' },
    { code: '+211', flag: 'SSD', country: 'South Sudan' },
    { code: '+34', flag: 'ESP', country: 'Spain' },
    { code: '+94', flag: 'LKA', country: 'Sri Lanka' },
    { code: '+249', flag: 'SDN', country: 'Sudan' },
    { code: '+597', flag: 'SUR', country: 'Suriname' },
    { code: '+268', flag: 'SWZ', country: 'Eswatini' },
    { code: '+46', flag: 'SWE', country: 'Sweden' },
    { code: '+41', flag: 'CHE', country: 'Switzerland' },
    { code: '+963', flag: 'SYR', country: 'Syria' },
    { code: '+886', flag: 'TWN', country: 'Taiwan' },
    { code: '+992', flag: 'TJK', country: 'Tajikistan' },
    { code: '+255', flag: 'TZA', country: 'Tanzania' },
    { code: '+66', flag: 'THA', country: 'Thailand' },
    { code: '+228', flag: 'TGO', country: 'Togo' },
    { code: '+690', flag: 'TKL', country: 'Tokelau' },
    { code: '+676', flag: 'TON', country: 'Tonga' },
    { code: '+1-868', flag: 'TTO', country: 'Trinidad and Tobago' },
    { code: '+216', flag: 'TUN', country: 'Tunisia' },
    { code: '+90', flag: 'TUR', country: 'Turkey' },
    { code: '+993', flag: 'TKM', country: 'Turkmenistan' },
    { code: '+1-649', flag: 'TCA', country: 'Turks and Caicos Islands' },
    { code: '+688', flag: 'TUV', country: 'Tuvalu' },
    { code: '+256', flag: 'UGA', country: 'Uganda' },
    { code: '+380', flag: 'UKR', country: 'Ukraine' },
    { code: '+971', flag: 'ARE', country: 'United Arab Emirates' },
    { code: '+44', flag: 'GBR', country: 'United Kingdom' },
    { code: '+1', flag: 'USA', country: 'United States' },
    { code: '+598', flag: 'URY', country: 'Uruguay' },
    { code: '+998', flag: 'UZB', country: 'Uzbekistan' },
    { code: '+678', flag: 'VUT', country: 'Vanuatu' },
    { code: '+379', flag: 'VAT', country: 'Vatican' },
    { code: '+58', flag: 'VEN', country: 'Venezuela' },
    { code: '+84', flag: 'VNM', country: 'Vietnam' },
    { code: '+681', flag: 'WLF', country: 'Wallis and Futuna' },
    { code: '+967', flag: 'YEM', country: 'Yemen' },
    { code: '+260', flag: 'ZMB', country: 'Zambia' },
    { code: '+263', flag: 'ZWE', country: 'Zimbabwe' }
  ];
  